import React from "react";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import { useField } from "formik";
import { Typography, Grid } from "@mui/material";
import propTypes from "prop-types";

export default function MaterialSwitch({ name, label }) {
  const [field, meta, helpers] = useField(name);
  return (
    <Grid container alignItems="center" justifyContent="space-between">
      <Typography variant="subtitle1" component={"span"}>
        {label}
      </Typography>
      <FormGroup {...field}>
        <FormControlLabel
          labelPlacement="start"
          control={
            <Switch
              color="primary"
              checked={meta.value}
              onChange={() => helpers.setValue(meta.value ? false : true)}
            />
          }
        />
      </FormGroup>
    </Grid>
  );
}

MaterialSwitch.propTypes = {
  name: propTypes.string,
  label: propTypes.string,
};
